import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Youtube, Linkedin } from "lucide-react";
import { useI18n } from "../i18n/I18nProvider";
import Monogram from "./Monogram";

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer className="bg-[#020203] border-t border-hair pt-24 pb-10" data-testid="site-footer">
      <div className="mx-auto max-w-[1440px] px-6 lg:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-20">
          <div className="md:col-span-5">
            <Monogram size={42} withWord />
            <p className="mt-6 max-w-sm text-ink-300 text-base leading-relaxed">{t.footer.tagline}</p>
            <div className="mt-8 flex items-center gap-4">
              <a href="https://instagram.com/phanerooprod" aria-label="Instagram — @phanerooprod" data-testid="footer-instagram" data-cursor="IG" className="text-ink-300 hover:text-ink-100" rel="noopener noreferrer" target="_blank"><Instagram size={18} /></a>
              <a href="https://youtube.com/@phanerooprod" aria-label="YouTube — @phanerooprod" data-testid="footer-youtube" data-cursor="YT" className="text-ink-300 hover:text-ink-100" rel="noopener noreferrer" target="_blank"><Youtube size={18} /></a>
              <a href="https://linkedin.com/company/phanerooprod" aria-label="LinkedIn — Phaneroo Prod" data-testid="footer-linkedin" data-cursor="LI" className="text-ink-300 hover:text-ink-100" rel="noopener noreferrer" target="_blank"><Linkedin size={18} /></a>
            </div>
          </div>
          <div className="md:col-span-3">
            <div className="text-[11px] tracking-[0.22em] uppercase text-ink-500 mb-4">{t.footer.links_title}</div>
            <ul className="space-y-3 text-ink-300 text-sm">
              <li><Link to="/services" className="hover:text-ink-100">{t.nav.services}</Link></li>
              <li><Link to="/portfolio" className="hover:text-ink-100">{t.nav.portfolio}</Link></li>
              <li><Link to="/studio" className="hover:text-ink-100">{t.nav.about}</Link></li>
              <li><Link to="/pricing" className="hover:text-ink-100">{t.nav.pricing}</Link></li>
              <li><Link to="/journal" className="hover:text-ink-100">{t.nav.blog}</Link></li>
              <li><Link to="/contact" className="hover:text-ink-100">{t.nav.contact}</Link></li>
            </ul>
          </div>
          <div className="md:col-span-4">
            <div className="text-[11px] tracking-[0.22em] uppercase text-ink-500 mb-4">{t.footer.contact_title}</div>
            <address className="not-italic">
              <ul className="space-y-3 text-ink-300 text-sm">
                <li itemProp="addressLocality">Moncton, NB · Canada</li>
                <li>
                  <a href="tel:+15068716122" data-testid="footer-phone" className="hover:text-ink-100" itemProp="telephone">+1 (506) 871-6122</a>
                </li>
                <li>
                  <a href="mailto:contact@phanerooventures.com" data-testid="footer-email" className="hover:text-ink-100" itemProp="email">contact@phanerooventures.com</a>
                </li>
                <li className="text-ink-500 text-[11px] tracking-wide pt-1">
                  Moncton · Fredericton · Saint John · Halifax · Charlottetown
                </li>
              </ul>
            </address>
          </div>
        </div>

        {/* <div className="select-none pointer-events-none -mb-4">
          <div className="font-serif-editorial leading-none tracking-tighter text-ink-100/90"
               style={{ fontSize: "clamp(3.5rem, 16vw, 16rem)" }}>
            PHANEROO PROD
          </div>
        </div> */}

        <div className="mt-12 pt-6 border-t border-hair flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-[11px] tracking-[0.18em] uppercase text-ink-500">
          <div>© {new Date().getFullYear()} {t.footer.built} {t.footer.rights}</div>
          <div className="flex items-center gap-6">
            {t.footer.legal.map((x) => (<span key={x}>{x}</span>))}
          </div>
        </div>
      </div>
    </footer>
  );
}
